module.exports = __webpack_public_path__ + "media/images/lb/368-e5c732ccc872ecfe14c591ffa05aba5a.svg";